<span class="text-lg" mat-dialog-title>{{ 'USER_DETAIL.MODAL_PASSWORD_TITLE' | transloco }}</span>
<div mat-dialog-content>
  <div class="message-box info w-full">
    {{ 'USER_DETAIL.PASSWORD_SAVE_SUCCESS' | transloco }}
  </div>
</div>
<div mat-dialog-actions class="flex justify-end">
  <button mat-raised-button color="primary" (click)="copyPassword()">
    {{ 'USER_DETAIL.BTN_COPY_PASSWORD' | transloco }}
  </button>
</div>
